"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewQueryStateQueryParam = void 0;
const react_1 = require("react");
const react_router_1 = require("react-router");
const view_query_params_models_1 = require("./view-query-params.models");
const view_query_params_utils_1 = require("./view-query-params.utils");
const useViewQueryStateQueryParam = () => {
    const { search } = (0, react_router_1.useLocation)();
    const encodedViewQueryState = (0, react_1.useMemo)(() => new URLSearchParams(search).get(view_query_params_models_1.VIEW_QUERY_STATE_QUERY_KEY), [search]);
    const viewQueryState = (0, react_1.useMemo)(() => (0, view_query_params_utils_1.decodeViewQueryState)(encodedViewQueryState), [encodedViewQueryState]);
    return {
        encodedViewQueryState,
        viewQueryState,
    };
};
exports.useViewQueryStateQueryParam = useViewQueryStateQueryParam;
